import axios, { AxiosResponse } from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

// function getUrl(config: any) {
//   if (config.baseURL) {
//     return config.url.replace(config.baseURL, "").split("?")[0]
//   }
//   return config.url
// }

export const instanceWithoutToken = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
})
export const instance = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
})

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['authorization'] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  async (config: any) => {
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

// const checkResponse = (error: any) => {
//   switch (error.response.status) {
//     case 403:
//       break;
//     case 400:
//       console.log(error.response.message);
//       break;
//     default:
//       console.log(
//         `%c ${error.response.status}  :`,
//         'color: red; font-weight: bold',
//         error.response.data
//       );
//   }
// };

instance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  function (error: any) {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.message === 'authorization invalid'
    ) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('role')
      window.location.href = '/login'
      return Promise.reject(error)
    }
    if (error.response) {
      return Promise.reject({
        status: error.response.status,
        message: error.response.data.message,
        // BE error code (e.g. PTO_POOL_STILL_OPEN) and the full body, for callers that branch on them
        error: error.response.data?.error,
        data: error.response.data,
      })
    } else if (error.request) {
      return Promise.reject(error.request)
    } else {
      return Promise.reject(error)
    }
  }
)
